import React from 'react';
import { useRouter } from 'next/router';
import { Hero, Spacer, Button, PenlySeo, ContentBoxContainer, VideoPlayer, ContentBoxText, ContentBoxFigure, ProductBox, Decoline, Testimonials, ArticlePreview, PageFAQ } from 'components';
import { mediaQueries, fromTabletMediaQuery, untilMobileMediaQuery } from 'utils/MediaQueriesDeprecated';
import { useProducts } from 'utils/products';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined'; // For "Tag styringen med vores hjælp"
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'; // For "Ekspertviden, som du ikke finder andre steder"
import { scrollToPageElement } from 'utils/componentsCommon';
import {  penlyInvestFAQEntries } from 'utils/texts';
import NedsparingOrder from './order/nedsparing-order';

const discounts = {
    webinar150524: {
        price: 4999,
        highlight: 'Normalpris 7.499 kr.',
    },
};

export default function Nedsparing() {
    const router = useRouter();
    const [showVideoDialog, setShowVideoDialog] = React.useState(false);
    const toggleVideo = () => {
        setShowVideoDialog(!showVideoDialog);
    };
    const description = 'Få investeringsrådgivning, der gør dig i stand til at tage styringen - trygt og  enkelt.';
    const image = { url: '/static/gfx/content/investering.jpg' };
    const fromTablet = mediaQueries(fromTabletMediaQuery);
    const untilMobile = mediaQueries(untilMobileMediaQuery);
    const products = useProducts();
    const product = products && products['invest-advisory-full'];
    const titletag = 'Investeringsrådgivning.  Bliv tryg i dine valg og få mere ud af dine penge';
    const metatag = 'Få uafhængig investeringsrådgivning, der giver dig overblik, indsigt og ro til at tage styringen over dine investeringer – uden skjulte gebyrer. Se mere.';

    const { code } = router.query;
    const discount = discounts[code];

    if (product && discount) {
        product.price.now = discount.price;
        product.highlight = discount.highlight;
    }

    return (
        <>
            <PenlySeo title={ titletag } description={ metatag } image={ image } noindex={ !!code }  />
            <Hero full={ true } overlay={ true } figure={ image.url } style={{}} className="left-box-blue">
                <section className="title" style={{ maxWidth: 670 }}>
                    <h1>
                        Få dine penge til at arbejde for dig med gennemsigtighed og klar retning
                    </h1>
                    <p style={{ maxWidth: 660 }}>{ description }</p>
                    <Spacer />
                    <Button onClick={ () => scrollToPageElement('#order', 0, 200) } size="large">
                        BESTIL INVESTERINGS&shy;RÅDGIVNING NU
                    </Button>
                </section>
            </Hero>
            <Spacer size="large" />
            <ContentBoxContainer className="mobileflip">
                <ContentBoxText className="background-highlight quote brbl">
                    <p>
                        Vi har set, hvordan skjulte gebyrer og såkaldt ‘gratis rådgivning’ i virkeligheden koster dyrt. Hos os anbefaler vi kun det, vi selv ville gøre. Uden undtagelser.


                        <br />
                        <br />
                        Søren Risager Rasmussen
                        <br />
                        Co-founder af Penly Invest
                    </p>
                    <Decoline />

                    { /* <Button variant='outline' noshadow={ true } style={{ width:'max-content', marginLeft:28, marginTop:20 }}  color="white" onClick={ () => setAutoPlay(true) }>SE FILM</Button> */ }

                </ContentBoxText>
                <ContentBoxFigure figure="/static/gfx/content/Soeren-Rasmussen_ai.png" className="servicelogoinline colorWhite brtr" onClick={ () => toggleVideo() }>
                    { /* <div className="videoPlay">
                        <img src="/static/gfx/PlayIcon.svg" style={{ marginTop:260 }} />
                    </div> */ }
                </ContentBoxFigure>
            </ContentBoxContainer>
            { /* { showVideoDialog && (
                <div className="modalOverlay" onClick={ () => toggleVideo() }>
                    <VideoPlayer videoId="UyfEXOfbcZc" autoPlay={ true } />
                </div>
            ) } */ }

            <Spacer size="medium" />
            <article id="why">
                <h2 style={{ textAlign: 'center', marginTop: 0 }}>Bliv klogere, stå stærkere og få mere ud af dine penge</h2>
                <p style={{ textAlign: 'center', marginTop: 0, fontSize:28 }}>Uvildig rådgivning, indsigt og tryghed – samlet ét sted.</p>
                <Spacer size="medium" />

                <div className="valueBoxes" style={{}}>
                    <div className="">
                        <div style={{ textAlign: 'center' }}>
                            <SentimentSatisfiedOutlinedIcon className="color-highlight" fontSize="large" />
                        </div>
                        <h5 style={{ textAlign: 'center' }}>Uvildig rådgivning –
                            intet salg</h5>
                        <p>Vi sælger ikke fonde og får ingen provision. Du betaler kun for selve rådgivningen – og vi sidder altid på din side af bordet.</p>
                    </div>
                    <div>
                        <div style={{ textAlign: 'center' }}>
                            <TrendingUpOutlinedIcon className="color-highlight" fontSize="large" />
                        </div>
                        <h5 style={{ textAlign: 'center' }}>Tag styringen med vores hjælp</h5>
                        <p>Vi gør investering forståeligt og hjælper dig til at tage styringen selv – med tryghed og tillid til dine egne valg.</p>
                    </div>
                    <div className="">
                        <div style={{ textAlign: 'center' }}>
                            <SchoolOutlinedIcon className="color-highlight" fontSize="large" />
                        </div>
                        <h5 style={{ textAlign: 'center' }}>Ekspertviden, som du ikke finder andre steder</h5>
                        <p>Uvildig rådgivning fra nogle af markedets mest erfarne eksperter – til en pris, hvor alle kan være med.</p>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                    <Button onClick={ () => scrollToPageElement('#order', 0, 200) } size="large">
                        BESTIL INVESTERINGS&shy;RÅDGIVNING NU
                    </Button>
                </div>
            </article>
            <Spacer size="small" />

            <ContentBoxContainer className="single">
                <ContentBoxText className="brbr background-primary" style={{ color: 'white' }}>
                    <h3>Viden, overblik og økonomisk selvtillid</h3>
                    <h5 >En <span className="color-highlight">investeringsrådgivning</span> hos Penly Invest giver dig:</h5>
                    <p>En analyse af din formue, gennemgang af dine muligheder og en konkret plan for, hvordan du kan optimere din formue. Planen tilpasses dine investeringshorisonter og din risikoprofil og har fokus på at sikre dig det bedst mulige risikojusterede afkast efter skat og omkostninger.</p>

                    <p>Vi tror ikke på hype og hurtige penge. Vi tror på gennemsigtighed, faglighed og en strategi, der tager udgangspunkt i dine mål og dit liv.</p>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                        <Button onClick={ () => scrollToPageElement('#order', 0, 200) } color="white" size={ fromTablet ? 'large' : 'medium' }>
                            BESTIL INVESTERINGS&shy;RÅDGIVNING NU
                        </Button>
                    </div>

                </ContentBoxText>
            </ContentBoxContainer>
            <Spacer size="large" />
            <Testimonials title="HVAD SIGER ANDRE OM INVESTERINGS&shy;RÅDGIVNING?" isNedsparing disableRandom />

            <Spacer size="large" />

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-5.jpg" className="brtl servicelogoinline colorWhite"></ContentBoxFigure>
                <ContentBoxText className="brbr background-primary" style={{ color: 'white' }}>
                    <h4>Sådan foregår en investeringsrådgivning</h4>
                    <p>En investeringsrådgivning består typisk af tre møder. Mellem møderne laver rådgiveren beregninger på baggrund af jeres ønsker og økonomi.</p>
                    <h6 className="color-highlight">Første møde</h6>
                    <p>Gennemgang af jeres formue og samtale om jeres ønsker og behov.  </p>
                    <h6 className="color-highlight">Andet møde</h6>
                    <p>Grundig analyse af jeres formue og behov samt en gennemgang af investeringsmulighederne. </p>
                    <h6 className="color-highlight">Tredje møde</h6>
                    <p>Endelig præsentation af anbefalingerne samt grundig gennemgang af  handleplanen. </p>
                    <Button onClick={ () => scrollToPageElement('#order', 0, 200) } color="white" size={ fromTablet ? 'large' : 'medium' }>
                        BESTIL investerings&shy;RÅDGIVNING NU
                    </Button>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />


            <article className="brtl" style={{ textAlign: 'center', paddingBottom: 0, backgroundColor: '#EEEEEE' }}>
                <h2 style={{ marginBottom: 0, marginTop: 20 }}>BESTIL investerings&shy;RÅDGIVNING</h2>
            </article>
            <ContentBoxContainer className="mobileflip" style={{ paddingTop: 0, backgroundColor: '#EEEEEE' }}>
                <ContentBoxText id="order" className="" style={{ paddingTop: 44 }}>
                    <NedsparingOrder product={ product } discountCode={ code } />
                </ContentBoxText>
                <ContentBoxText style={{ paddingTop: 44, paddingBottom: 0 }}>
                    <div style={{ height: '80%', display: 'flex', justifyContent: 'flex-start', marginBottom: untilMobile ? -20 : 40 }} className="productBoxes">
                        { product && <ProductBox showNote style={{ height: '108%', maxHeight:1300 }} product={ product } elementId={ product.id } orderMode={ true } /> }
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>
            <Spacer size="large" />
            <ArticlePreview
                firstArticleSlug={ 'sadan-laegger-du-en-god-investerings-strategi-nar-du-naermer-dig-pensionen' }
                secondArticleSlug={ 'derfor-er-investering-relevant-for-pensionister' }
            />
            <Spacer size="large" />
            <ContentBoxContainer className="mobileflip">
                <ContentBoxText className="brbl brtr background-primary" style={{ color: 'white' }}>
                    <h2 >Gør som over 14.000 andre</h2>
                    <p style={{ fontSize:26, lineHeight:1.1, maxWidth:360 }}>Få viden og værktøjer til din privatøkonomi plus invitationer til events, webinarer mv. Du kan til hver en tid afmelde dig. </p>

                </ContentBoxText>

                <ContentBoxText className="" style={{ color: 'white' }}>
                    <iframe
                        src={ 'https://app.heyloyalty.com/subscribe/28266/8273' }
                        width="100%"
                        height="400px"
                        style={{ border: 'none', overflow: 'hidden', minHeight: '400px' }}
                    >
                    </iframe>
                </ContentBoxText>
            </ContentBoxContainer>
            <Spacer size="large" />
            <PageFAQ answerMarginTop={ 0 } title="FAQ" faqEntries={ penlyInvestFAQEntries } />

            <Spacer size="large" />
            <ContentBoxContainer className="single" style={{ justifyContent: 'center', marginBottom: '100px' }}>
                <ContentBoxText className="brbr background-primary" style={{ color: 'white' }}>
                    <h3>Har du spørgsmål?</h3>
                    <p>
                        Send en e-mail til <a href={ 'mailto:kontakt@penly.dk' }> kontakt@penly.dk </a>
                        eller ring til os på <a href={ 'tel:+45 93 83 83 72' }> +45 93 83 83 72</a>. Du kan ringe til os tirsdag og torsdag mellem 10.00 og 14.00.
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>
        </>
    );
}
